// extracted by mini-css-extract-plugin
export default {"preloader":"Loader_preloader__Y5snp","hide":"Loader_hide__F+G5I","loader":"Loader_loader__-Fmy+","spin":"Loader_spin__0cJZd"};